import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingStatisticAdmin: false,
  totalAdmin: null,
  totalRole: null,
  loadingStatisticRole: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_STATISTIC_ADMIN: (s, data) => (s.loadingStatisticAdmin = data),
    SET_TOTAL_ADMIN: (s, data) => (s.totalAdmin = data),
    LOAD_STATISTIC_ROLE: (s, data) => (s.loadingStatisticRole = data),
    SET_TOTAL_ROLE: (s, data) => (s.totalRole = data),
  },

  actions: {
    async getTotalAdmin({ commit }) {
      commit("LOAD_STATISTIC_ADMIN", true);
      try {
        const res = await this.$api.get("/v1/portal/users", {
          params: {
            isAdminUser: 1,
            page: 1,
            limit: 1,
          },
        });
        const totalAdmins = res.data.pagination.total;

        commit("SET_TOTAL_ADMIN", totalAdmins);
        return totalAdmins;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_STATISTIC_ADMIN", false);
      }
    },
    async getTotalRole({ commit }) {
      commit("LOAD_STATISTIC_ROLE", true);
      try {
        const res = await this.$api.get("/v1/portal/roles", {
          params: {
            page: 1,
            limit: 1,
          },
        });
        const totalRoles = res.data.pagination.total;

        commit("SET_TOTAL_ROLE", totalRoles);
        return totalRoles;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_STATISTIC_ROLE", false);
      }
    },
  },
};
